import { useState, useRef, useEffect } from "react";
import { Quote, ChevronLeft, ChevronRight, X } from "lucide-react";

// Curated testimonials with full and short quotes
const testimonials = [
  {
    name: "Mark Hassin",
    title: "Chief Operating Officer",
    company: "Paystand",
    image: "https://customer-assets.emergentagent.com/job_efficiency-boost-10/artifacts/2zgve0yp_image.png",
    preview: "Dan operates in the top 5% of employees I've worked with. Strong execution, real impact, and measurable outcomes—every time.",
    full: "Dan is one of those rare operators who consistently delivers at a very high level, regardless of the role or the problem in front of him. I've had the opportunity to work with Dan multiple times, and every time the result was the same. Strong execution, real impact, and measurable outcomes. That is not a coincidence. When you bring Dan into the business, things move faster, get more structured, and ultimately perform better. What makes Dan different is not just his work ethic, although he works harder than most. It is how deeply he cares. He cares about the business, he cares about the people, and he takes ownership well beyond what is expected. That combination is rare. Dan has operated across SDR, AE, leadership, RevOps, and Marketing. He does not hide behind a title. He steps into whatever the business needs and figures it out. From a pure value perspective, Dan operates in the top tier of employees I have worked with. Top 5 percent, consistently."
  },
  {
    name: "Mike Cartmill",
    title: "Head of Sales",
    company: "Paystand",
    image: "https://customer-assets.emergentagent.com/job_efficiency-boost-10/artifacts/q1sd7550_IMG_0169.jpeg",
    preview: "Under his leadership, SDR-sourced conversion rates doubled and revenue tripled over two years.",
    full: "I've had the pleasure of working with Dan Leitner twice, and both times I was struck by his grit, curiosity, and ability to solve complex challenges quickly and effectively. Whether he's coaching his team or vetting the bleeding edge of sales technology, Dan sets a high bar and focuses on work that drives real impact. I saw this firsthand in his execution. Under his leadership, SDR-sourced lead conversion rates doubled and revenue tripled over a two-year period. He was also instrumental in architecting and scaling an AI-powered SDR system that augmented human outreach, significantly increasing rep productivity and driving measurable gains in pipeline generation. He doesn't shy away from tough or unexpected situations. He leans into them and consistently finds a path forward. Overcoming challenges seems wired into his DNA. Just as importantly, Dan is a consummate relationship builder. He brings intensity and focus, but pairs it with a genuine ability to connect with people and earn their trust."
  },
  {
    name: "Nick Bell",
    title: "RVP Sales Development",
    company: "Five9",
    image: "https://customer-assets.emergentagent.com/job_ai-sdr-platform-3/artifacts/u5rz8436_image.png",
    preview: "Working under Dan's leadership was one of the most impactful experiences of my career.",
    full: "Working under Dan's leadership as Director of Sales Development at Ushur was one of the most impactful experiences of my career. Dan's ability to align our SDR team around clear KPIs and OKRs, while driving real business results, was transformative. Together, we built a team culture focused on accountability, continuous improvement, and high performance. Dan has a rare ability to balance strategic vision with tactical execution, and he genuinely invests in the growth and development of his people. I would welcome the opportunity to work with Dan again in any capacity."
  },
  {
    name: "Kashif Mahbub",
    title: "Chief Marketing Officer",
    company: "Ushur",
    image: null,
    preview: "Dan doesn't just build pipeline. He builds systems, develops talent, and creates functions that drive real business outcomes.",
    full: "Dan Leitner is one of the most impactful SDR leaders I've had the opportunity to work with. What stands out most about Dan is his relentless focus on performance and his commitment to the craft. His ability to dive deep into the numbers while still leading and inspiring a team is rare. Dan doesn't just build pipeline. He builds systems, develops talent, and creates functions that drive real business outcomes. Any organization looking to strengthen their go-to-market engine would benefit from his leadership."
  },
  {
    name: "Morgan Spade",
    title: "Director of Sales",
    company: "Paystand",
    image: "https://customer-assets.emergentagent.com/job_ai-sdr-platform-3/artifacts/c371lvwf_image.png",
    preview: "His commitment to elevating team performance is unmatched. Dan is deeply data-driven and delivers real business outcomes.",
    full: "Dan Leitner is one of the most dedicated and thoughtful professionals I've had the pleasure of working with. His commitment to elevating team performance is unmatched-he creates a culture where continuous improvement is not just encouraged, but expected. Dan is deeply data-driven and uses insights to make informed decisions that drive real business outcomes. His leadership style inspires trust and motivates teams to achieve their full potential."
  },
  {
    name: "Andreea Ioana",
    title: "Director of Sales",
    company: "emerie.ai",
    image: "https://customer-assets.emergentagent.com/job_ai-sdr-platform-3/artifacts/rm29dc0v_image.png",
    preview: "Dan demonstrated exceptional leadership qualities. His trustworthiness and strategic mindset distinguish him from the rest.",
    full: "I had the privilege of working with Dan, who demonstrated exceptional leadership qualities. His trustworthiness, strategic mindset, dedication, and empathy distinguish him from the rest. Dan is a role model for his team and ensures that everyone has an equal opportunity to succeed. He creates an environment where people feel valued and motivated to perform at their best. His ability to navigate complex challenges while maintaining team morale is truly impressive."
  },
  {
    name: "Brandon Murphy",
    title: "Software Sales Leader",
    company: "Enterprise GTM",
    image: "https://customer-assets.emergentagent.com/job_ai-sdr-platform-3/artifacts/qig8d5sg_image.png",
    preview: "Dan is an outstanding leader, communicator, and problem-solver with deep understanding of sales.",
    full: "I had the pleasure of working with Dan as my manager for the past 2 years at Ushur. He is an outstanding leader, communicator, and problem-solver. Dan has a deep understanding of the sales process and is able to effectively coach and mentor his team members. He is also very data-driven and uses metrics to inform his decisions and drive continuous improvement. Dan's leadership style is collaborative and empowering-he gives his team the autonomy to succeed while providing the support and guidance needed."
  },
  {
    name: "Edgardo Flores",
    title: "Sales Leader",
    company: "",
    image: "https://customer-assets.emergentagent.com/job_ai-sdr-platform-3/artifacts/pu8xp210_image.png",
    preview: "Dan has been the best sales leader I've had the chance of working with. He's invested in his people.",
    full: "Dan has been the best sales leader I've had the chance of working with. He's a great culture leader, very accessible, effective managing up, down, and with cross-functional management. He is invested in his people and is a great translator of the business down to the front lines. Dan creates an environment where every team member feels empowered to contribute and grow."
  },
  {
    name: "Max Robbins",
    title: "Revenue Operations",
    company: "",
    image: "https://customer-assets.emergentagent.com/job_ai-sdr-platform-3/artifacts/vit1odjv_image.png",
    preview: "His focus on data-centric decision making and thinking outside the box is a dangerous combination.",
    full: "I've had the pleasure of working with Dan for several years. His focus on data-centric decision making and proclivity to think outside of the box is a dangerous combination. Always seeing the big picture and delivering value-added, impact-driven insights, he is able to lead his team with clarity and purpose. Dan's ability to translate complex data into actionable strategies sets him apart as a leader in the revenue operations space."
  },
  {
    name: "Jeff Takahashi",
    title: "Marketing Ops Leader",
    company: "RevOps",
    image: "https://customer-assets.emergentagent.com/job_ai-sdr-platform-3/artifacts/zie9odzx_image.png",
    preview: "Dan's strategic thinking and ability to bridge marketing and sales is impressive. He's a true partner.",
    full: "Dan and I worked together at Ushur and collaborated on many projects ranging from developing our growth team tech stack to setting marketing KPIs and OKRs. Our roles under the Marketing function, although separate, required us to work closely together on an almost daily basis. I was consistently impressed by Dan's strategic thinking, his ability to bridge the gap between marketing and sales, and his commitment to driving measurable results. He's a true partner in every sense of the word."
  }
];

// Testimonial Modal Component
const TestimonialModal = ({ testimonial, isOpen, onClose, onNext, onPrev, hasNext, hasPrev }) => {
  // Lock body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !testimonial) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm animate-fadeIn" />
      
      {/* Modal Content */}
      <div 
        className="relative w-full sm:w-auto sm:max-w-lg mx-0 sm:mx-4 bg-[#1C1C1C] rounded-t-3xl sm:rounded-2xl border border-white/10 max-h-[85vh] overflow-hidden animate-slideUp sm:animate-fadeIn"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 sm:p-5 border-b border-white/10">
          <div className="flex items-center gap-3">
            {testimonial.image ? (
              <img 
                src={testimonial.image}
                alt={testimonial.name}
                className="w-12 h-12 rounded-full object-cover"
              />
            ) : (
              <div className="w-12 h-12 rounded-full bg-[#D4AF37]/20 flex items-center justify-center">
                <span className="text-[#D4AF37] font-semibold text-lg">{testimonial.name.charAt(0)}</span>
              </div>
            )}
            <div>
              <div className="font-semibold text-white">{testimonial.name}</div>
              <div className="text-sm text-zinc-400">
                {testimonial.title}{testimonial.company && `, ${testimonial.company}`}
              </div>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center text-zinc-400 hover:text-white transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        {/* Body */}
        <div className="p-5 sm:p-6 overflow-y-auto max-h-[50vh]">
          <Quote className="w-8 h-8 text-[#D4AF37]/30 mb-4" />
          <p className="text-base sm:text-lg text-zinc-200 leading-relaxed">
            "{testimonial.full}"
          </p>
        </div>
        
        {/* Navigation Footer */}
        <div className="flex items-center justify-between p-4 border-t border-white/10 bg-[#0A0A0A]/50">
          <button
            onClick={onPrev}
            disabled={!hasPrev}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              hasPrev 
                ? 'text-white hover:bg-white/10' 
                : 'text-zinc-600 cursor-not-allowed'
            }`}
          >
            <ChevronLeft className="w-4 h-4" />
            Previous
          </button>
          <button
            onClick={onNext}
            disabled={!hasNext}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              hasNext 
                ? 'text-white hover:bg-white/10' 
                : 'text-zinc-600 cursor-not-allowed'
            }`}
          >
            Next
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

// Carousel Card Component
const CarouselCard = ({ testimonial, index, onReadMore }) => (
  <div 
    className="flex-shrink-0 w-[85vw] sm:w-[380px] snap-center"
    data-testid={`testimonial-card-${index}`}
  >
    <div className="h-[280px] sm:h-[260px] mx-2 p-5 bg-[#0A0A0A] rounded-2xl border border-white/10 flex flex-col">
      {/* Quote Icon */}
      <Quote className="w-6 h-6 text-[#D4AF37]/40 mb-3 flex-shrink-0" />
      
      {/* Preview Quote - Fixed height with line clamp */}
      <p className="text-base text-zinc-200 leading-relaxed line-clamp-4 flex-1">
        "{testimonial.preview}"
      </p>
      
      {/* Read Full Review Link */}
      <button
        onClick={() => onReadMore(index)}
        className="text-sm text-[#D4AF37] font-medium hover:text-[#E8C547] transition-colors flex items-center gap-1 mt-3 self-start"
        data-testid={`read-more-${index}`}
      >
        Read full review
        <ChevronRight className="w-4 h-4" />
      </button>
      
      {/* Author */}
      <div className="flex items-center gap-3 pt-4 mt-3 border-t border-white/10">
        {testimonial.image ? (
          <img 
            src={testimonial.image}
            alt={testimonial.name}
            className="w-10 h-10 rounded-full object-cover flex-shrink-0"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-[#D4AF37]/20 flex items-center justify-center flex-shrink-0">
            <span className="text-[#D4AF37] font-semibold">{testimonial.name.charAt(0)}</span>
          </div>
        )}
        <div className="min-w-0">
          <div className="font-semibold text-white text-sm">{testimonial.name}</div>
          <div className="text-xs text-zinc-400 truncate">
            {testimonial.title}{testimonial.company && `, ${testimonial.company}`}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const TestimonialsSection = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef(null);

  const openModal = (index) => {
    setActiveIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const goToNext = () => {
    if (activeIndex < testimonials.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  const goToPrev = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === 'left' ? -340 : 340;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section id="testimonials" className="py-12 sm:py-16 lg:py-20 bg-[#1C1C1C]">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-8 sm:mb-10">
          <div className="text-xs sm:text-sm font-mono text-[#D4AF37] tracking-widest uppercase mb-3">References</div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white tracking-tight">
            What Leaders & Teammates Say
          </h2>
        </div>
      </div>

      {/* Carousel */}
      <div className="relative">
        {/* Navigation Arrows - Desktop only */}
        <button 
          onClick={() => scroll('left')}
          className="hidden lg:flex absolute left-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-[#0A0A0A]/80 border border-white/10 rounded-full items-center justify-center text-white hover:bg-[#D4AF37]/20 hover:border-[#D4AF37]/40 transition-all"
          aria-label="Previous testimonial"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        
        <button 
          onClick={() => scroll('right')}
          className="hidden lg:flex absolute right-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-[#0A0A0A]/80 border border-white/10 rounded-full items-center justify-center text-white hover:bg-[#D4AF37]/20 hover:border-[#D4AF37]/40 transition-all"
          aria-label="Next testimonial"
        >
          <ChevronRight className="w-5 h-5" />
        </button>

        {/* Scrollable Container */}
        <div 
          ref={scrollRef}
          className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-4 px-4 sm:px-6 lg:px-12 -mx-2"
          style={{ 
            scrollbarWidth: 'none', 
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch'
          }}
        >
          {testimonials.map((testimonial, index) => (
            <CarouselCard 
              key={testimonial.name} 
              testimonial={testimonial} 
              index={index}
              onReadMore={openModal}
            />
          ))}
        </div>

        {/* Scroll Indicator - Mobile */}
        <div className="flex justify-center gap-1.5 mt-4 lg:hidden">
          {testimonials.slice(0, 5).map((testimonial) => (
            <div 
              key={testimonial.name}
              className="w-1.5 h-1.5 rounded-full bg-white/30"
            />
          ))}
          {testimonials.length > 5 && (
            <span className="text-xs text-zinc-500 ml-1">+{testimonials.length - 5}</span>
          )}
        </div>
      </div>

      {/* Testimonial count */}
      <div className="text-center mt-6">
        <span className="text-sm text-zinc-500">
          {testimonials.length} recommendations from colleagues and partners
        </span>
      </div>

      {/* Modal */}
      <TestimonialModal
        testimonial={testimonials[activeIndex]}
        isOpen={modalOpen}
        onClose={closeModal}
        onNext={goToNext}
        onPrev={goToPrev}
        hasNext={activeIndex < testimonials.length - 1}
        hasPrev={activeIndex > 0}
      />
    </section>
  );
};

export default TestimonialsSection;
